import { useTranslation } from 'react-i18next';

import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';

const StagingChip = () => {
  const { t } = useTranslation('sites');

  return (
    <Chip
      size="small"
      label={
        <Typography variant="h5" color="text.primary">
          {t('cloud.staging.stagingTxt')}
        </Typography>
      }
      sx={{
        backgroundColor: 'warning.main',
        borderRadius: 2,
      }}
    />
  );
};

export default StagingChip;
